import type { AllStatesResponse } from './api';

export const normalizeAllStatesList = (list: AllStatesResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.stateDesc,
    value: row.stateCode,
  }));
};
